export const TERMS_LABEL = {
  privacy: "개인정보 수집·이용",
  service: "서비스 이용약관",
  marketing: "마케팅 정보 수신·활용",
};

export const TOURNAMENT_LABEL = {
  protest: "대회 참가 약관",
  privacy: "개인정보 수집 및 활용 동의서",
  marketing: "마케팅 정보 수신·활용",
};

export const LOGIN_DIALOG_LABEL = {
  title: "로그인 안내",
  content: "로그인이 필요한 서비스입니다.\n로그인을 진행해주세요.",
};

export const TELECOM_MENU = [
  { label: "SKT", value: "1" },
  { label: "KT", value: "2" },
  { label: "LG U+", value: "3" },
  { label: "SKT 알뜰폰", value: "5" },
  { label: "KT 알뜰폰", value: "6" },
  { label: "LG U+ 알뜰폰", value: "7" },
];

export const VIRTUAL_ACCOUNT_MENU = [
  { label: "입금하실 은행을 선택해주세요.", value: "-1", imagePath: "" },
  { label: "우리은행", value: "1", imagePath: "ic-bank-woori.webp" },
  { label: "기업은행", value: "2", imagePath: "ic-bank-ibk.webp" },
  { label: "국민은행", value: "3", imagePath: "ic-bank-kb.webp" },
  { label: "농협은행", value: "5", imagePath: "ic-bank-nh.webp" },
  { label: "하나은행", value: "6", imagePath: "ic-bank-hana.webp" },
  { label: "신한은행", value: "7", imagePath: "ic-bank-sinhan.webp" },
  { label: "SC제일은행", value: "8", imagePath: "ic-bank-sc.webp" },
  { label: "iM뱅크(대구)", value: "9", imagePath: "ic-bank-im.webp" },
  { label: "우체국", value: "10", imagePath: "ic-bank-epost.webp" },
  { label: "케이뱅크", value: "11", imagePath: "ic-bank-kbank.webp" },
];

export const PAYMENT_LABEL = {
  rule: "파크골프장 규칙 및 취소/환불 규정 동의",
  privacy: "개인정보 수집 및 활용 동의서",
  provide: "개인정보 제 3자 제공 동의",
  service: "결제 대행 서비스 약관 동의",
};
